import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { TranslatorConverter } from "src/TranslatorConverter";
import { Enum, IEnumTranslator, PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { CreateCodeConversionViewModel } from "../createCodeConversion/createCodeConversion-viewModel";
import { CreateInternalTransferViewModel } from "../createInternalTransfer/createInternalTransfer-viewModel";
import { InternalTransferDetailViewModel } from "../internalTransferDetail/internalTransferDetail-viewModel";
import  { InternalTransferListView } from "./internalTransferList-view"

export class InternalTransferListViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'انبار به انبار کد به کد';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.internalTransfers = ObservableArray.create<InternalTransfer>();
        this.internalTransferEnumProvider = new InternalTransferEnumProvider;
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),30);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new InternalTransferListView();
    }
    public getTypeId(): string {
        return "VM-FE1AAB34-9BB3-4C49-9373-047E9EB553F8"
    }
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set internalTransfers(v: ObservableArray<InternalTransfer>) { this._internalTransfer = v; } public get internalTransfers(): ObservableArray<InternalTransfer> { return this._internalTransfer;} private _internalTransfer: ObservableArray<InternalTransfer>;
    public set internalTransferEnumProvider(v: InternalTransferEnumProvider) { this._internalTransferEnumProvider = v; } public get internalTransferEnumProvider(): InternalTransferEnumProvider { return this._internalTransferEnumProvider;} private _internalTransferEnumProvider: InternalTransferEnumProvider;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseTransferServices/ListAllInternalWarehouseTransfers',{
                FurtherQueryInfo:filteringInformation,
            });
            this.internalTransfers.update(...result.Requests.map((q,i)=>{
                let r = new InternalTransfer(this);
                r.rowNumber = i+1;
                r.transferId = q.Id;
                r.orderCode = q.OrderCode;
                r.canOrder = stringIsNullOrEmpty(q.OrderCode);
                r.canReceipt = !r.canOrder && stringIsNullOrEmpty(q.ReceiptCode);
                r.transferType = q.TransferType;
                r.transferTypeName = q.TransferTypeName;
                r.issueTime = moment.utc(q.IssueTime);
                r.orderTime = q.OrderTime==null ? null : moment.utc(q.OrderTime);
                r.receiptTime = q.ReceiptTime==null ? null : moment.utc(q.ReceiptTime);
                r.fromWarehouseId = q.FromWarehouseId;
                r.fromWarehouseName = q.FromWarehouseName;
                r.toWarehouseId = q.ToWarehouseId;
                r.toWarehouseName = q.ToWarehouseName;
                r.receiptCode = q.ReceiptCode;
                r.comment = q.Comment;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }

    refreshClosePopups() {
        this.isShowingPopup = false;
        this.refresh();
    }
    
    async showDetail (id:string) {
        let invoiceDetail = new InternalTransferDetailViewModel(this, id);
        let result = await this.showPopup(invoiceDetail);
    }
    
    async createInternalTransfer() {
        let result = await this.showPopup(new CreateInternalTransferViewModel(this));
        this.refresh();
    }
    
    async createCodeConversion() {
        let result = await this.showPopup(new CreateCodeConversionViewModel(this));
        this.refresh();
    }
}

export class InternalTransfer extends ViewModel{
    
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:InternalTransferListViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set transferType(v: number) { this._transferType = v; } public get transferType(): number { return this._transferType;} private _transferType: number;
    public set transferTypeName(v: string) { this._transferTypeName = v; } public get transferTypeName(): string { return this._transferTypeName;} private _transferTypeName: string;
    public set fromWarehouseId(v: string) { this._fromWarehouseId = v; } public get fromWarehouseId(): string { return this._fromWarehouseId;} private _fromWarehouseId: string;
    public set fromWarehouseName(v: string) { this._fromWarehouseName = v; } public get fromWarehouseName(): string { return this._fromWarehouseName;} private _fromWarehouseName: string;
    public set toWarehouseId(v: string) { this._toWarehouseId = v; } public get toWarehouseId(): string { return this._toWarehouseId;} private _toWarehouseId: string;
    public set toWarehouseName(v: string) { this._toWarehouseName = v; } public get toWarehouseName(): string { return this._toWarehouseName;} private _toWarehouseName: string;
    public set transferId(v: string) { this._transferId = v; } public get transferId(): string { return this._transferId;} private _transferId: string;
    public set orderCode(v: number) { this._orderCode = v; } public get orderCode(): number { return this._orderCode;} private _orderCode: number;
    public set issueTime(v: moment.Moment) { this._issueTime = v; } public get issueTime(): moment.Moment { return this._issueTime;} private _issueTime: moment.Moment;
    public set orderTime(v: moment.Moment) { this._orderTime = v; } public get orderTime(): moment.Moment { return this._orderTime;} private _orderTime: moment.Moment;
    public set receiptTime(v: moment.Moment) { this._receiptTime = v; } public get receiptTime(): moment.Moment { return this._receiptTime;} private _receiptTime: moment.Moment;
    public set receiptCode(v: string) { this._receiptCode = v; } public get receiptCode(): string { return this._receiptCode;} private _receiptCode: string;
    public set canOrder(v: boolean) { this._canOrder = v; } public get canOrder(): boolean { return this._canOrder;} private _canOrder: boolean;
    public set canReceipt(v: boolean) { this._canReceipt = v; } public get canReceipt(): boolean { return this._canReceipt;} private _canReceipt: boolean;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment;} private _comment: string;
    
    private _typedParent:InternalTransferListViewModel;

    async showDetail(){
        this._typedParent.showDetail(this.transferId);
    }  

    async order(){
        try {
            let confirmation ='';
            confirmation = await this.messageBoxWarningYesNo('آیا این سطر حواله شود؟','درخواست حواله');
            if(confirmation=='no'){
                return;
            }
            this._typedParent.isLoading = true;
            let result =await ServerConnection.callServer('/Complex/WarehouseTransferServices/CreateOrderForInternalTransfer',{
                TransferType: this.transferType,
                TransferTypeName: this.transferTypeName,
                InternalTransfer: this.transferId
            });
            if (!result.IsSuccessful) {
                throw 'New Error';
            }
            await this.messageBoxConfirmSuccess('حواله با موفقیت ثبت شد.','عملیات موفق');
            this._typedParent.refresh();
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this._typedParent.isLoading = false;
        }
    }  

    async receipt(){
        try {
            let confirmation ='';
            confirmation = await this.messageBoxWarningYesNo('آیا این سطر رسید شود؟','درخواست رسید');
            if(confirmation=='no'){
                return;
            }
            this._typedParent.isLoading = true;
            let result =await ServerConnection.callServer('/Complex/WarehouseTransferServices/CreateReceiptForInternalTransfer',{
                TransferType: this.transferType,
                TransferTypeName: this.transferTypeName,
                InternalTransfer: this.transferId
            });
            if (!result.IsSuccessful) {
                throw 'New Error';
            }
            await this.messageBoxConfirmSuccess('رسید با موفقیت ثبت شد.','عملیات موفق');
            this._typedParent.refresh();
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this._typedParent.isLoading = false;
        }
    }  

}

export class InternalTransferEnumProvider extends Enum implements IEnumTranslator{
    constructor() {
        super();
        this.values = [10,11];
        this.translator = this;
        this.converter = new TranslatorConverter(); 
    }
    private converter:TranslatorConverter;
    GetString(value: any) {
        return this.converter.translateInternalTransferType(value);
    }
}

